module.exports = __webpack_public_path__ + "img/dark.443ae033.jpg";